var render = function render(){var _vm=this,_c=_vm._self._c;return _c('diff-file-options-dropdown',{ref:"diff-file-options-dropdown",attrs:{"items":_vm.groups,"file-id":_vm.fileId,"old-path":_vm.oldPath,"new-path":_vm.newPath}})
}
var staticRenderFns = []

export { render, staticRenderFns }